import AddEmp from "./pages/Account/ME/AddEmp";
import React, { FC, ReactElement, useEffect } from "react";
import { Route, Switch , useLocation} from "react-router-dom";
import { useDispatch } from "react-redux";
import "antd/dist/antd.css";
import { BackTop } from "antd";
import AboutPage from "./pages/AboutPage/AboutPage";

import TermsPage from "./pages/Policy/TermsPage";
import PrivacyPage from "./pages/Policy/PrivacyPage";
import RefundPage from "./pages/Policy/RefundPage";
import ShippingPage from "./pages/Policy/ShippingPage";
import ContactPage from "./pages/Policy/ContactPage";


import {
  ACCOUNT,
  ACTIVATE,
  BASE,
  CART,
  CONTACTS,
  FORGOT,
  LOGIN,
  MENU,
  OAUTH2_REDIRECT,
  ORDER,
  ORDER_FINALIZE,
  PRODUCT,
  REGISTRATION,
  RESET,
  ACCOUNT_ADMIN_PERFUMES,
  ACCOUNT_ADMIN_EDIT
} from "./constants/routeConstants";

import { fetchCart } from "./redux-toolkit/cart/cart-thunks";
import { fetchUserInfo } from "./redux-toolkit/user/user-thunks";
import Login from "./pages/Login/Login";
import StaffLogin from "./pages/Login/StaffLogin";
import FinDashboard from "./pages/Dashboard/FinDashboard";
import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import Registration from "./pages/Registration/Registration";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Menu from "./pages/Menu/Menu";
import Contacts from "./pages/Contacts/Contacts";
import Cart from "./pages/Cart/Cart";
import Order from "./pages/Order/Order";
import Home from "./pages/Home/Home";
import Product from "./pages/Product/Product";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Account from "./pages/Account/Account";
import OrderFinalize from "./pages/OrderFinalize/OrderFinalize";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import OAuth2RedirectHandler from "./utils/oauth2/OAuth2RedirectHandler";
import EditPerfume from "./pages/Account/EditPerfume/EditPerfume";
import InvoicePage from "./pages/Account/OrdersList/InvoicePage";
import "./App.css";
import ProtectedRoute from "./ProtectedRoute";



const App: FC = (): ReactElement => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isStaffRoute =
    location.pathname.startsWith("/fin") ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/staff");

  useEffect(() => {
    const perfumesFromLocalStorage: Map<number, number> = new Map(
      JSON.parse(localStorage.getItem("perfumes") as string)
    );
    dispatch(fetchCart(Array.from(perfumesFromLocalStorage.keys())));

    if (localStorage.getItem("token")) {
      dispatch(fetchUserInfo());
    }
  }, []);

  return (
    <div className="app-root">
      {/* Header */}
      { <NavBar />}

      {/* Scrollable Content */}
      <div className="app-content">
        <Switch>
          <Route exact path={BASE} component={Home} />
          <Route exact path={LOGIN} component={Login} />
          <Route exact path={REGISTRATION} component={Registration} />
          <Route exact path={FORGOT} component={ForgotPassword} />
          <Route exact path={`${RESET}/:code`} component={ResetPassword} />
          <Route exact path={`${ACTIVATE}/:code`} component={Login} />
          <Route exact path={MENU} component={Menu} />
          <Route exact path={`${PRODUCT}/:id`} component={Product} />
          <Route exact path={CONTACTS} component={Contacts} />
          <Route exact path={CART} component={Cart} />
          <Route exact path={ORDER} component={Order} />
          <Route exact path={ORDER_FINALIZE} component={OrderFinalize} />
          <Route path={OAUTH2_REDIRECT} component={OAuth2RedirectHandler} />
          <Route exact path="/about" component={AboutPage} />
          <Route path="/staff/login" component={StaffLogin} />
          <ProtectedRoute
            path="/fin/dashboard"
            component={FinDashboard}
            allowedRoles={["2"]} // ME
          />

          <ProtectedRoute
            path="/add-emp"
            component={AddEmp}
            allowedRoles={["1" ,"2", "4"]}
          />

          <ProtectedRoute
            path="/admin/dashboard"
            component={AdminDashboard}
            allowedRoles={["1"]} // ADMIN
          />

          <Route path="/terms" component={TermsPage} />
          <Route path="/privacy" component={PrivacyPage} />
          <Route path="/refund-policy" component={RefundPage} />
          <Route path="/shipping-policy" component={ShippingPage} />
          <Route path="/contact-us" component={ContactPage} />

          <Route exact path={`${ACCOUNT_ADMIN_PERFUMES}/edit/:id`} component={EditPerfume} />
          <Route exact path={`${ACCOUNT_ADMIN_EDIT}/:id`} component={EditPerfume} />
          <Route path="/account/user/order/invoice/:id" component={InvoicePage} />

          <Route
            path={ACCOUNT}
            render={() =>
              localStorage.getItem("token") ? (
                <Account />
              ) : (
                <Home />
              )
            }
          />

          <Route path="*" component={Home} />
        </Switch>
      </div>

      {/* Footer */}
      {!isStaffRoute && <Footer />}

      <BackTop />
    </div>
  );

};

export default App;
